import { ReactComponent as ArrowLeftRegularIcon } from "../../assets/icons/arrow-left-regular.svg";
import { ReactComponent as XMarkRegularIcon } from "../../assets/icons/font-awesome/xmark-regular.svg";

type TPopoverHeaderWithNavProps = {
  className?: string;
  title: string;
  onClose?: () => void;
  onGoBack: () => void;
};

const PopoverHeaderWithNav = ({
  className = "",
  onClose,
  title,
  onGoBack,
}: TPopoverHeaderWithNavProps) => {
  return (
    <div className={`${className}`}>
      <div className={`p-16 dr-flex dr-items-center`}>
        <div
          className="dr-flex-1 dr-flex dr-justify-start dr-cursor-pointer"
          onClick={onGoBack}
        >
          <ArrowLeftRegularIcon className="dr-h-14 dr-min-w-14" />
        </div>
        <div className="dr-flex-1 dr-flex dr-justify-center BodyBody1Bold">
          {title}
        </div>
        <div className="dr-flex-1 dr-flex dr-justify-end" onClick={onClose}>
          <XMarkRegularIcon className="dr-h-14 dr-min-w-14 dr-cursor-pointer" />
        </div>
      </div>
      <div className="dr-h-1 dr-bg-doctor-darwin-neutral-200" />
    </div>
  );
};

export default PopoverHeaderWithNav;
